/* Interior motion and a document index. No cart, variant or checkout interception. */
(() => {
  const reduced = {get matches(){return document.body.dataset.heerMotion === 'off'},addEventListener(type,callback){document.addEventListener('heer:motion-change',callback)}};
  const scenes = new Set();
  let raf = 0;
  const clamp = n => Math.max(0, Math.min(1, n));
  const frame = () => {
    raf = 0;
    const extent = document.documentElement.scrollHeight - innerHeight;
    document.documentElement.style.setProperty('--hv-read', String(extent > 0 ? clamp(scrollY / extent) : 0));
    for (const el of scenes) {
      if (!el.isConnected) { scenes.delete(el); continue; }
      if (reduced.matches) continue;
      const b = el.getBoundingClientRect();
      if (b.bottom > 0 && b.top < innerHeight) el.style.setProperty('--hv-scene', clamp((innerHeight - b.top) / (innerHeight + b.height)).toFixed(4));
    }
    for (const nav of document.querySelectorAll('[data-hv-toc]')) {
      const links = [...nav.querySelectorAll('a')];
      let current = links[0];
      for (const a of links) { const h = document.getElementById(a.hash.slice(1)); if (h && h.getBoundingClientRect().top < innerHeight * .4) current = a; }
      for (const a of links) { if (a === current) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); }
    }
  };
  const schedule = () => { if (!raf) raf = requestAnimationFrame(frame); };
  const reveals = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const e of entries) if (e.isIntersecting) { if (!reduced.matches) e.target.classList.add('hv-reveal-in'); reveals.unobserve(e.target); }
  }, { threshold: .06 }) : null;
  function mount(root) {
    root.querySelectorAll('[data-hv-scene]').forEach(el => { scenes.add(el); el.classList.toggle('hv-depth-ready', !reduced.matches); });
    root.querySelectorAll('[data-hv-reveal],.hv-catalog .grid__item,.hv-dossier__copy,.hv-contact__info').forEach(el => {
      if (!el.dataset.hvObserved) { el.dataset.hvObserved = 'true'; reveals?.observe(el); }
    });
    root.querySelectorAll('.hv-reading').forEach((reading, index) => {
      const nav = reading.querySelector('[data-hv-toc]');
      if (!nav || nav.childElementCount) return;
      const headings = [...reading.querySelectorAll('[data-hv-content] h2,[data-hv-content] h3')].filter(h => h.getClientRects().length);
      headings.forEach((h, i) => {
        if (!h.id) h.id = `heer-chapter-${reading.id || index}-${i}`;
        const a = document.createElement('a'); a.href = '#' + h.id; a.textContent = String(i + 1).padStart(2, '0') + ' / ' + h.textContent.trim(); nav.append(a);
      });
      if (!headings.length) reading.querySelector('.hv-reading__aside > .hr-label')?.setAttribute('hidden', '');
    });
    schedule();
  }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  let pointerFrame = 0;
  document.addEventListener('pointermove', event => {
    if (reduced.matches || event.pointerType !== 'mouse' || pointerFrame) return;
    const scene = event.target.closest('.hv-masthead');
    if (!scene) return;
    pointerFrame = requestAnimationFrame(() => { const b = scene.getBoundingClientRect(); scene.style.setProperty('--hv-light-x', ((event.clientX-b.left)/b.width*100)+'%'); scene.style.setProperty('--hv-light-y', ((event.clientY-b.top)/b.height*100)+'%'); pointerFrame=0; });
  }, {passive:true});
  reduced.addEventListener('change', () => { scenes.forEach(el => el.classList.toggle('hv-depth-ready', !reduced.matches)); schedule(); });
  document.addEventListener('shopify:section:load', e => mount(e.target));
  document.addEventListener('shopify:section:unload', e => { e.target.querySelectorAll('[data-hv-scene]').forEach(el => scenes.delete(el)); });
  // Native facet filtering replaces the result node. Re-observe only added content.
  const main = document.getElementById('MainContent');
  if (main && 'MutationObserver' in window) new MutationObserver(records => {
    for (const r of records) for (const node of r.addedNodes) if (node.nodeType === 1 && (node.matches?.('.hv-catalog') || node.querySelector?.('.hv-catalog'))) mount(node.parentElement || node);
  }).observe(main, { childList: true, subtree: true });
  mount(document);
  document.querySelectorAll('media-gallery .product__media-list').forEach(gallery => {
    new MutationObserver(records => {
      if (reduced.matches) return;
      for (const record of records) if (record.target.matches('.is-active')) {
        const image = record.target.querySelector('.product__media img');
        image?.animate([{clipPath:'inset(0 18% 0 0)',opacity:.5},{clipPath:'inset(0)',opacity:1}], {duration:650,easing:'cubic-bezier(.2,.7,.2,1)'});
      }
    }).observe(gallery, {subtree:true,attributes:true,attributeFilter:['class']});
  });
})();
